import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { firstValueFrom } from 'rxjs';
import { ApiService, StreetHouseRow } from '../../../shared/services/api.service';
import { StreetSubjectProfileDialogComponent } from './street-subject-profile-dialog.component';

@Component({
  selector: 'app-street-info',
  templateUrl: './street-info.component.html',
  styleUrls: ['./street-info.component.css'],
})
export class StreetInfoComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  streetName = '';
  suburbName = '';
  isLoading = true;
  dataSource = new MatTableDataSource<StreetHouseRow>([]);
  displayedColumns: string[] = ['fullName', 'houseNumber', 'erfNumber', 'actions'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  async ngOnInit(): Promise<void> {
    this.streetName = (this.route.snapshot.queryParamMap.get('streetName') || '').trim();
    this.suburbName = (this.route.snapshot.queryParamMap.get('suburbName') || '').trim();

    if (!this.streetName || !this.suburbName) {
      await this.router.navigate(['/admin/street-search']);
      return;
    }

    await this.loadRows();
  }

  async loadRows(): Promise<void> {
    this.isLoading = true;
    try {
      const response = await firstValueFrom(
        this.apiService.listStreetHouses(this.streetName, this.suburbName)
      );
      this.dataSource.data = response.rows || [];
      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    } catch (error) {
      console.error('Failed to load street houses:', error);
      this.snackBar.open('Failed to load street info', 'Close', { duration: 4500 });
    } finally {
      this.isLoading = false;
    }
  }

  applyFilter(value: string): void {
    this.dataSource.filter = value.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  async openSubjectProfile(row: StreetHouseRow): Promise<void> {
    if (!row.subjectId) {
      return;
    }
    this.dialog.open(StreetSubjectProfileDialogComponent, {
      width: '900px',
      maxWidth: '95vw',
      data: { subjectId: row.subjectId, fallbackName: row.fullName || null },
    });
  }

  async backToMap(): Promise<void> {
    await this.router.navigate(['/admin/street-search']);
  }
}
